// Call links with the do-not-call check — window.CallButton + window.CallGuard.
//
// A phone number in Atlas is DealCloud free text ("(916) 468-8893    (Work)",
// two numbers in one field, an extension), so it goes through
// window.AtlasPhone.parsePhones (mobile/people.jsx — loaded later in the
// bundle, so it is read at render time, never at load). A person the calling
// team marked do not call (contacts' do_not_call, the Calls panel's flag) is
// a warning, not a block — a dealmaker may own the relationship: the link
// asks first (window.showConfirm), then opens the same tel:/sms: link.
//
//   <window.CallButton phone={raw.phone} doNotCall={raw.do_not_call} name="Pat" />
//     variant 'links' (default): each number as a link, `text` adds an sms link
//     variant 'icon': one small phone icon per number (desktop headers / rows)
//     fallback: rendered when nothing in the field is dialable
//
// CallGuard is the same check for places that draw their own <a> (the phone
// People list, the phone company page): linkClick(href, dnc, kind, name) is
// an <a>'s onClick, dial(href, dnc, kind, name) navigates (after asking).

const callGuardAsk = (kind, name) => window.showConfirm({
  title: 'Marked do not call',
  body: `The calling team marked ${name || 'this person'} as do not call.`,
  confirmLabel: kind === 'text' ? 'Text anyway' : 'Call anyway',
  danger: true,
});

const callGuardDial = (href, doNotCall, kind = 'call', name) => {
  if (!href) return;
  if (!doNotCall) { window.location.href = href; return; }
  callGuardAsk(kind, name).then((ok) => { if (ok) window.location.href = href; });
};

// onClick for a tel:/sms: <a>. Never lets the click reach a row behind the
// link (rows open the record); a do-not-call one holds the link and asks.
const callGuardLinkClick = (href, doNotCall, kind = 'call', name) => (e) => {
  if (e && e.stopPropagation) e.stopPropagation();
  if (!doNotCall) return;
  if (e && e.preventDefault) e.preventDefault();
  callGuardDial(href, true, kind, name);
};

const CallButton = ({ phone, doNotCall = false, name, text = false, variant = 'links', size = 12, fallback = null, style }) => {
  const kit = window.AtlasPhone;
  const phones = phone && kit && kit.parsePhones ? kit.parsePhones(phone) : [];
  if (!phones.length) return fallback;
  const dnc = !!doNotCall;
  const MsgIcon = (kit && kit.MsgIcon) || null;
  const iconLink = {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: 2, borderRadius: 4,
    color: dnc ? 'var(--rose-fg)' : 'var(--accent-text)', textDecoration: 'none', lineHeight: 0, flexShrink: 0,
  };

  if (variant === 'icon') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2, ...style }}>
        {phones.map((ph) => (
          <a key={ph.tel} href={ph.tel} onClick={callGuardLinkClick(ph.tel, dnc, 'call', name)}
             aria-label={`Call ${ph.display}`} title={`Call ${ph.display}${dnc ? ' · do not call' : ''}`} style={iconLink}>
            <Icon.Phone size={size} />
          </a>
        ))}
      </span>
    );
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', ...style }}>
      {phones.map((ph) => (
        <span key={ph.tel} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
          <a href={ph.tel} onClick={callGuardLinkClick(ph.tel, dnc, 'call', name)}
             title={dnc ? 'Do not call' : undefined}
             style={{ color: 'var(--accent-text)', textDecoration: 'none' }}>{ph.display}</a>
          {text && MsgIcon && (
            <a href={ph.sms} onClick={callGuardLinkClick(ph.sms, dnc, 'text', name)}
               aria-label={`Text ${ph.display}`} title="Text" style={iconLink}>
              <MsgIcon size={size} />
            </a>
          )}
        </span>
      ))}
    </span>
  );
};

window.CallButton = CallButton;
window.CallGuard = { ask: callGuardAsk, dial: callGuardDial, linkClick: callGuardLinkClick };
